export default "__VITE_ASSET__BmhEIAHb__"